import * as D from "@radix-ui/react-dialog";
import type { ReactNode } from "react";

export function Dialog({ open, onOpenChange, children }: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  children: ReactNode;
}) {
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      <D.Portal>
        <D.Overlay className="fixed inset-0 z-40 bg-black/40 data-[state=open]:animate-in data-[state=closed]:animate-out" />
        <D.Content
          onOpenAutoFocus={(e) => e.preventDefault()}
          className="fixed left-1/2 top-1/2 z-50 w-[min(560px,calc(100vw-32px))] -translate-x-1/2 -translate-y-1/2 rounded-lg border border-gray-200 bg-white p-6 shadow-xl focus:outline-none"
        >
          {children}
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}

export function DialogTitle({ children }: { children: ReactNode }) {
  return <D.Title className="text-lg font-semibold text-gray-900">{children}</D.Title>;
}

export function DialogDescription({ children }: { children: ReactNode }) {
  return <D.Description className="text-sm text-gray-500 mt-1">{children}</D.Description>;
}

export function DialogClose({ children, asChild }: { children: ReactNode; asChild?: boolean }) {
  return <D.Close asChild={asChild}>{children}</D.Close>;
}
